import React from "react";
import PropTypes from "prop-types";
import { WhiteSpace as WhiteSpaceComponent } from "../../sharedComponents/WhiteSpace";

const WhiteSpace = ({ pixelHeight }) => <WhiteSpaceComponent pixelHeight={pixelHeight} />;

WhiteSpace.propTypes = {
	pixelHeight: PropTypes.number,
};
WhiteSpace.defaultProps = {
	pixelHeight: 50,
};

export default WhiteSpace;
export { WhiteSpace };
